export default function ContactPage() {
  return (
    <section className="hero-bg pt-[170px] pb-4" data-testid="contact-page">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
        <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Contacto</p>
        <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl" data-testid="contact-title">Hablemos</h1>
      </div>
    </section>
  );
}
